import { ArrowDropDown } from '@mui/icons-material'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import { getPublicCompressed } from '@toruslabs/eccrypto'
import axios from 'axios'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { ThreeDots } from 'react-loader-spinner'
import { useWeb3Auth } from '../../../services/web3auth'
import useAuthStore from '../../../store/authStore'
import useUploadStore from '../../../store/uploadStore'
import { truncateMiddle } from '../../../utils'

const DesktopTopBar = ({
  currentCategory,
  currentQuery,
  setSearchCategory,
  parent,
}: any) => {
  const [searchBox, setSearchBox] = useState(false)
  const [loader, setLoader] = useState<boolean>(true)
  const [saltBalance, setSaltBalance] = useState<any>()
  const [maticBalance, setMaticBalance] = useState<any>()
  const [walletAddress, setWalletAddress] = useState<string>('')
  const [categoryOpen, setCategoryOpen] = useState<boolean>(false)
  const router = useRouter()
  const { setActiveStep, setCurrentCategory, setUploadAssetId } =
    useUploadStore()

  const [active, setActive] = useState('')

  const user_id = useAuthStore((state) => state.userInfo)

  // For getting user verified
  const [secretKey, setSecretKey] = useState<any>()
  const [idToken, setIdToken] = useState<any>()
  const [typeOfLogin, setTypeOfLogin] = useState<any>()

  const { getCategoryList, categoryList } = useUploadStore()
  const { setCurrentUser, setOpenLogginDetails } = useAuthStore()
  const { logout } = useWeb3Auth()

  const [category, setCategory] = useState('All Categories')
  let [userName, setUserName] = useState<string>('')
  let [userProfileImage, setUserProfileImage] = useState<string>('')
  const [menu, setMenu] = useState(false)

  useEffect(() => {
    const path = router.route
    if (path === '/') setActive('discover')
    else setActive(path.slice(1).split('/')?.[0])
  }, [category, active, router])

  useEffect(() => {
    getCategoryList()
    if (walletAddress) return
    let x = setInterval(function () {
      setLoader(false)
    }, 4000)
    return () => clearInterval(x)
  }, [])

  const {
    provider,
    getAccounts,
    getMaticBalance,
    getPrivateKey,
    isLoading,
    metaMaskSign,
  } = useWeb3Auth()

  async function getCredentials() {
    setLoader(true)
    const wallet = await localStorage.getItem('WalletAddress')
    if (wallet !== null && wallet !== undefined) {
      setUserName(wallet)
      setLoader(false)
    }
    const crendetials = await localStorage.getItem('openlogin_store')
    if (crendetials !== null && crendetials !== undefined) {
      const user = JSON.parse(crendetials)
      setOpenLogginDetails(JSON.parse(crendetials))
      setIdToken(user.idToken)
      setTypeOfLogin(user.typeOfLogin)
    }
    setLoader(false)
  }

  useEffect(() => {
    if (provider) {
      if (
        !user_id ||
        user_id == undefined ||
        !walletAddress ||
        walletAddress == undefined
      )
        return
      const config = { user: { uid: user_id } }
      // console.log('config', config)
      axios
        .post(
          'https://us-central1-test-69192.cloudfunctions.net/userAuth/getWallet',
          config
        )
        .then((res) => {
          // const data = res?.data?.data?.data
          if (res?.data?.data?.salt) {
            setSaltBalance(res?.data?.data?.salt)
          } else {
            setSaltBalance(0)
          }
        })
        .catch((e) => {
          console.log(e)
        })

      Object.assign(config, { wallet_address: walletAddress })
      // console.log('Data is', config)
      if (typeOfLogin == 'jwt') {
        axios
          .post(
            'https://us-central1-test-69192.cloudfunctions.net/userAuth/updateWallet',
            config
          )
          .then((res) => console.log(res))
          .catch((e) => console.log(e.response?.data?.message))
      }
    }
  }, [user_id, provider, walletAddress])

  useEffect(() => {
    if (provider) {
      getAccounts().then(() => {
        const address = localStorage.getItem('WalletAddress')
        if (address !== null && address !== undefined) {
          setWalletAddress(address)
          // console.log(walletAddress)
        }
      })
      if (walletAddress != '' && !isLoading && !loader) {
        getMaticBalance().then((data) =>
          setMaticBalance((data / 1e18).toFixed(2))
        )
      }

      const adapter = localStorage.getItem('Web3Auth-cachedAdapter')

      // TODO:
      if (adapter == 'wallet-connect-v1') {
        const walletConnect = localStorage.getItem('walletconnect')
        if (walletConnect !== null && walletConnect !== undefined) {
          // console.log('Hello there', walletConnect)
          // console.log('walletconnect login flow ')
          metaMaskSign()
            .then((data) => {
              const uid = data?.data?.data?.wallet?.address
              if (uid != undefined) {
                setCurrentUser(uid)
                localStorage.setItem('uid', uid)
              }
            })
            .catch((e) => {
              console.log(e)
            })

          localStorage.setItem('signature', '1')
        }
      }
      const isSigned = localStorage.getItem('signature')
      if (adapter == 'metamask' && isSigned == '0') {
        // console.log('metamask login flow ')
        metaMaskSign()
          .then((data) => {
            const uid = data?.data?.data?.wallet?.address

            if (uid != undefined) {
              setCurrentUser(uid)
              localStorage.setItem('uid', uid)
            }
          })
          .catch((e) => {
            // console.log(e)
          })

        localStorage.setItem('signature', '1')
      }

      if (typeOfLogin == 'discord') {
        // console.log('Only Discord Login goes here')
        // localStorage.setItem('uid', walletAddress)
        getPrivateKey().then((data) => {
          // console.log(data)
          setSecretKey(data)
        })

        let app_pub_key

        if (secretKey != undefined) {
          app_pub_key = getPublicCompressed(
            Buffer.from(secretKey.padStart(64, '0'), 'hex')
          ).toString('hex')
        }
        // console.log('secret key', secretKey)
        // console.log('app_pub_key', app_pub_key)

        const verifierData = {
          app_pub_key: app_pub_key,
          idToken: idToken,
          address: walletAddress,
          name: userName,
        }
        // console.log(verifierData)

        axios
          .post(
            'https://us-central1-test-69192.cloudfunctions.net/app/getverified-social',
            verifierData
          )
          .then((res) => {
            // console.log('response for discode', res)
            setCurrentUser(walletAddress)
            localStorage.setItem('uid', walletAddress)
          })
          .catch((e) => {
            // console.log(e)
          })
      }

      if (typeOfLogin == 'jwt' && localStorage.getItem('uid') === null) {
        const crendetials = localStorage.getItem('openlogin_store')
        if (crendetials !== null && crendetials !== undefined) {
          const user = JSON.parse(crendetials)
          // localStorage.setItem('uid', user.verifierId)
          const authToken = user.oAuthIdToken

          const config = {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
          const body = {
            idToken: authToken,
          }
          // console.log(config)
          axios
            .post(
              'https://us-central1-test-69192.cloudfunctions.net/app/valid',
              body,
              config
            )
            .then(async (res) => {
              // console.log('response', res)
              // console.log('result', JSON.parse(res.data.data.token))
              const result = JSON.parse(res.data.data.token)
              setCurrentUser(result.uid)
              localStorage.setItem('uid', result.uid)
            })
            .catch((e) => {
              console.log('error occured', e)
            })
        }
      }

      if (!userName || !userProfileImage) {
        getCredentials()
      }
    }
  }, [userName, loader, getAccounts, provider, walletAddress])

  const openMenu = (type: string) => {
    if (type === 'open') {
      setMenu(true)
      document.body.style.overflow = 'hidden'
    } else {
      setMenu(false)
      document.body.style.overflow = 'auto'
    }
  }
  return (
    <div className="hidden flex-row items-center justify-center md:flex">
      <a
        href="https://alter.game/whitepaper"
        target="_blank"
        rel="noreferrer"
        className="group inset-y-0 mb-1 ml-1 -skew-x-12 transform border-b-2 border-white/10 bg-white/10 px-6 py-3 hover:cursor-pointer hover:border-primary"
      >
        <div className="skew-x-12 transform text-white group-hover:text-primary">
          <span className="font-MonumentRegular text-[12px] uppercase tracking-widest">
            Whitepaper
          </span>
        </div>
      </a>
      <div className="group inset-y-0 mb-1 ml-1 -skew-x-12 transform border-b-2 border-primary bg-white/10 px-6 py-3 hover:cursor-pointer">
        <div className="skew-x-12 transform text-primary">
          <span className="font-MonumentRegular text-[12px] uppercase tracking-widest">
            shop
          </span>
        </div>
      </div>
      <div className="group inset-y-0 mb-1 ml-1 -skew-x-12 transform border-b-2 border-white/10 bg-white/10 px-6 py-3 hover:cursor-pointer hover:border-primary">
        <div className="skew-x-12 transform text-white group-hover:text-primary">
          <span className="font-MonumentRegular text-[12px] uppercase tracking-widest">
            Map
          </span>
        </div>
      </div>
      <div className="group inset-y-0 mb-1 ml-1 -skew-x-12 transform border-b-2 border-white/10 bg-white/10 px-6 py-3 hover:cursor-pointer hover:border-primary">
        <div className="skew-x-12 transform text-white group-hover:text-primary">
          <span className="font-MonumentRegular text-[12px] uppercase tracking-widest">
            Dive In
          </span>
        </div>
      </div>
      <>
        {isLoading ? (
          <div className="w-52">
            <div className="-mr-2  flex -skew-x-12 transform items-center justify-center bg-primary px-6 py-3">
              <ThreeDots
                color="black"
                height={22}
                width={40}
                ariaLabel="loading-indicator"
              />
            </div>
          </div>
        ) : walletAddress && provider ? (
          <div className="group relative z-50">
            <button
              className="group relative z-10 -mr-2 flex w-auto -skew-x-12 transform bg-primary  px-6 py-3 outline-none"
              id="userName_btn"
            >
              <Image
                className="mr-4 h-20 w-20 skew-x-12 rounded-full"
                src={userProfileImage || '/images/auth/contacts_icon.svg'}
                height={20}
                width={20}
                alt="Profile Image"
              />
              <p className="tranform ml-2 skew-x-12 font-MonumentRegular text-sm uppercase">
                {truncateMiddle(userName)}
              </p>
              <ArrowDropDown />
            </button>
            {/* {actions ? ( */}
            <div
              className="absolute top-12 right-0 z-0 -mr-5 -mt-10 hidden w-[111%] skew-y-12 flex-col items-start overflow-hidden border-[1px] border-primary bg-black font-oswaldregular uppercase transition-all group-hover:flex "
              style={{
                // clipPath: 'inset(24% 10% 0px 0px)',
                clipPath: 'polygon(0% 28%, 100% 0%, 100% 100%, 0% 100%)',
              }}
            >
              <Link href="/">
                <div className="mt-10 flex w-full -skew-y-12 cursor-pointer flex-row items-center justify-start px-4 py-4 text-white hover:bg-primary hover:text-black ">
                  <AccountCircleIcon className="" />
                  <span className="ml-2 ">My account</span>
                </div>
              </Link>
              <Link href="/wallet">
                <div className="flex w-full -skew-y-12 cursor-pointer flex-row items-center justify-start px-4 py-4 text-white hover:bg-primary hover:text-black ">
                  <AccountBalanceWalletIcon className="" />
                  <span className="ml-2 ">My Wallet</span>
                </div>
              </Link>
              <div
                className="mb-5 flex w-full -skew-y-12 cursor-pointer flex-row items-center justify-start px-4 py-4 text-white hover:bg-primary hover:text-black "
                onClick={() => {
                  console.log('logging out')
                  logout()
                  // window.location.reload()
                  setCurrentUser(null)
                  setOpenLogginDetails(null)
                }}
              >
                <PowerSettingsNewIcon className="" />
                <span className="ml-2 ">Logout</span>
              </div>
            </div>
            {/* ) : (
              <></>
            )} */}
          </div>
        ) : loader ? (
          <div className="w-52">
            <div className="-mr-2 flex -skew-x-12 transform items-center justify-center bg-primary py-3">
              <ThreeDots
                color="black"
                height={22}
                width={40}
                ariaLabel="loading-indicator"
              />
            </div>
          </div>
        ) : (
          <Link href="/login">
            <button
              id="connect_btn"
              className="-mr-2 w-52 -skew-x-12 transform bg-yellow-300 px-6 py-3"
              onClick={async () => {
                localStorage.setItem('method', '1')
              }}
            >
              <div className="tranform skew-x-12 font-MonumentRegular text-sm uppercase">
                Connect
              </div>
            </button>
          </Link>
        )}
      </>
    </div>
  )
}
export default DesktopTopBar
